import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import BoardType from 'src/app/model/product/board/board-type';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import IPBoardPlacementType, {
  IPBoardPlacementTypeChoices,
} from 'src/app/model/product/ip-board/ip-board-placement-type';
import Address from 'src/app/model/project/address';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { SubProject } from 'src/app/model/project/sub-project';
import { ImmoIPSubProjectChangesObject } from 'src/app/services/immo-ip-placer-offline-changes/immo-ip-sub-project-changes/immo-ip-sub-project-changes-object';

export class OfflineStorageTourModifiedConfigHelper {
  private constructor() {}

  static applyModifiedConfig(
    subProject: SubProject,
    changeObject: ImmoIPSubProjectChangesObject
  ): void {
    if (subProject != null && changeObject != null) {
      OfflineStorageTourModifiedConfigHelper.applyModifiedConfigToAddressRelatedFields(
        subProject.projectPlacement,
        changeObject.address
      );
    }

    if (
      subProject == null ||
      (changeObject.boardType == null && changeObject.placementType == null) ||
      subProject.project == null ||
      !CollectionHelper.isPopulated(subProject.project.products)
    ) {
      return;
    }

    const ipBoard = subProject.project.products.find((p) =>
      ProductHelper.isIPBoard(p)
    ) as IPBoard;

    OfflineStorageTourModifiedConfigHelper.applyModifiedConfigToPlacementRelatedFields(
      ipBoard,
      subProject.projectPlacement,
      changeObject.placementType
    );

    if (ipBoard == null) {
      return;
    }

    OfflineStorageTourModifiedConfigHelper.applyModifiedConfigToIPBoard(
      ipBoard,
      changeObject.boardType,
      changeObject.placementType
    );
  }

  private static applyModifiedConfigToPlacementRelatedFields(
    ipBoard: IPBoard,
    projectPlacement: ProjectPlacement,
    modifiedPlacementType: IPBoardPlacementType
  ): void {
    if (modifiedPlacementType == null) {
      return;
    }

    if (
      ipBoard != null &&
      modifiedPlacementType.ordinal !==
        IPBoardPlacementTypeChoices.ON_POSTS.ordinal &&
      modifiedPlacementType.ordinal !==
        IPBoardPlacementTypeChoices.ON_STONES.ordinal
    ) {
      ipBoard.poleColor = null;
    }

    if (projectPlacement == null) {
      return;
    }

    if (
      modifiedPlacementType.ordinal ===
        IPBoardPlacementTypeChoices.ON_POSTS.ordinal ||
      modifiedPlacementType.ordinal ===
        IPBoardPlacementTypeChoices.ON_STONES.ordinal
    ) {
      projectPlacement.placementFloor = null;
    }

    if (
      modifiedPlacementType.ordinal !== IPBoardPlacementTypeChoices.ON_POSTS
    ) {
      projectPlacement.undergroundPipework = null;
      projectPlacement.undergroundPipeworkText = null;
    }
  }

  private static applyModifiedConfigToIPBoard(
    ipBoard: IPBoard,
    modifiedBoardType: BoardType,
    modifiedPlacementType: IPBoardPlacementType
  ): void {
    if (ipBoard.boardPart == null) {
      return;
    }

    const ipBoardPart = ipBoard.boardPart;

    OfflineStorageTourModifiedConfigHelper.applyModifiedBoardTypeToIPBoard(
      ipBoard,
      ipBoardPart,
      modifiedBoardType
    );

    ipBoardPart.boardType =
      modifiedBoardType == null ? ipBoardPart.boardType : modifiedBoardType;
    ipBoardPart.placementType =
      modifiedPlacementType == null
        ? ipBoardPart.placementType
        : modifiedPlacementType;
  }

  private static applyModifiedBoardTypeToIPBoard(
    ipBoard: IPBoard,
    ipBoardPart: IPBoardPart,
    modifiedBoardType: BoardType
  ): void {
    if (modifiedBoardType == null) {
      return;
    }

    if (
      (ipBoardPart.boardType == null ||
        BoardTypeChoices.SINGLE_SIDED.ordinal !==
          ipBoardPart.boardType.ordinal) &&
      BoardTypeChoices.SINGLE_SIDED.ordinal === modifiedBoardType.ordinal
    ) {
      ipBoardPart.otherSideOtherTitle = ipBoardPart.otherTitle;
      ipBoardPart.otherTitleAdjustment = ipBoardPart.titleAdjustment;
      ipBoardPart.otherSideOtherPhoneNumber = ipBoardPart.otherPhoneNumber;
      ipBoardPart.otherPhoneNumberAdjustment =
        ipBoardPart.phoneNumberAdjustment;
      ipBoardPart.otherCustomText = null;
      ipBoard.leftRightBoard = false;
      ipBoard.otherSideBoardPart = null;
    } else if (
      ipBoardPart.boardType != null &&
      BoardTypeChoices.SINGLE_SIDED.ordinal === ipBoardPart.boardType.ordinal &&
      BoardTypeChoices.SINGLE_SIDED.ordinal !== modifiedBoardType.ordinal
    ) {
      ipBoardPart.otherSideOtherTitle = ipBoardPart.otherTitle;
      ipBoardPart.otherTitleAdjustment = ipBoardPart.titleAdjustment;
      ipBoardPart.otherSideOtherPhoneNumber = ipBoardPart.otherPhoneNumber;
      ipBoardPart.otherPhoneNumberAdjustment =
        ipBoardPart.phoneNumberAdjustment;

      if (BoardTypeChoices.V.ordinal === modifiedBoardType.ordinal) {
        ipBoardPart.otherCustomText = ipBoardPart.customText;
      } else if (BoardTypeChoices.DOUBLE_SIDED === modifiedBoardType.ordinal) {
        ipBoardPart.otherCustomText = null;
      }
    } else if (
      BoardTypeChoices.DOUBLE_SIDED.ordinal === modifiedBoardType.ordinal
    ) {
      if (
        ipBoardPart.boardType != null &&
        BoardTypeChoices.V.ordinal === ipBoardPart.boardType.ordinal &&
        !ipBoard.leftRightBoard &&
        (ProductHelper.doTitleSidesDiffer(ipBoardPart) ||
          ProductHelper.doPhoneNumberSidesDiffer(ipBoardPart))
      ) {
        ipBoardPart.otherSideOtherTitle = ipBoardPart.otherTitle;
        ipBoardPart.otherTitleAdjustment = ipBoardPart.titleAdjustment;
        ipBoardPart.otherSideOtherPhoneNumber = ipBoardPart.otherPhoneNumber;
        ipBoardPart.otherPhoneNumberAdjustment =
          ipBoardPart.phoneNumberAdjustment;
      }
      ipBoardPart.customText = null;
    }
  }

  private static applyModifiedConfigToAddressRelatedFields(
    projectPlacement: ProjectPlacement,
    modifiedAddress: Address
  ): void {
    if (projectPlacement == null || modifiedAddress == null) {
      return;
    }
    projectPlacement.address.line1 = modifiedAddress.line1;
    projectPlacement.address.postalCode = modifiedAddress.postalCode;
    projectPlacement.address.city = modifiedAddress.city;
    projectPlacement.address.province = modifiedAddress.province;
    projectPlacement.address.country = modifiedAddress.country;
  }
}
